import { render, staticRenderFns } from "./ModalEnvioTeste.vue?vue&type=template&id=bb6da5a8&scoped=true"
import script from "./ModalEnvioTeste.vue?vue&type=script&lang=js"
export * from "./ModalEnvioTeste.vue?vue&type=script&lang=js"
import style0 from "./ModalEnvioTeste.vue?vue&type=style&index=0&id=bb6da5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6da5a8",
  null
  
)

export default component.exports